<template>
    <div class="cart">
        <Navbar >
            <!--            <template v-slot:navMsg v-if="showCurrentYearDisallowed">-->
            <!--                <TempAvailabilityMessage v-if="products.length > 0" />-->
            <!--            </template>-->
        </Navbar>

        <section class="py-4 bg-light mt-3" style="min-height: 50vh">
            <div class="container">
                <h3 class="mb-3">Shopping Cart</h3>
                

                <div v-if="subtotal >= 5000" class="alert alert-warning">
                    <h5>Wow, This looks like a big order!</h5>
                    <div>
                        Please contact us at: <a href="tel:8663118734">(866) 311-8734</a> for assistance.
                    </div>
                </div>

                <div v-if="products && products.length && productsInCartToCheck == 0">
                    <ul class="list-group mb-3">
                        <li v-for="(product, productKey) in products" :key="productKey" class="list-group-item product">

                            <pre style='display: none'>{{product}}</pre>

                            <div class="d-flex">

                                <div class="align-self-center">
                                    <div v-if="product.format">
                                        <router-link v-if="product.cover" :to="getProductLink(product)">
                                            <img :src="'//cdn.studiesweekly.com/' + product.cover" class="rounded cover-image">
                                        </router-link>
                                    </div>
                                    <div v-else>
                                        <router-link v-if="product.thumbnail" :to="{name: 'supplemental-product', params: {sku: product.sku}}">
                                            <img :src="product.thumbnail" class="rounded cover-image">
                                        </router-link>
                                    </div>
                                </div>

                                <div class="align-self-center mx-3">

                                    <div v-if="product.format">
                                        <router-link :to="getProductLink(product)" class="text-dark">
                                            <h6 class="mb-0">
                                                {{product.title}} - {{price(product.prices, product.format, 'classroom', product.quantity, multiyear).yearstotal | currency}}/ {{multiyear}} Year Subscription
                                            </h6>
                                        </router-link>
                                    </div>
                                    <div v-else-if="product.routeName">
                                        <router-link :to="{name: product.routeName}" class="text-dark">
                                            <h6 class="mb-0">
                                                {{product.name}}
                                            </h6>
                                        </router-link>
                                    </div>
                                    <div v-else>
                                        <router-link :to="{name: 'burrito-products', params: {sku: product.sku}}" class="text-dark">
                                            <h6 class="mb-0">
                                                {{product.name}}
                                            </h6>
                                        </router-link>
                                    </div>

                                    <small class="d-block">
                                        <div v-if="product.state" class="mt-2">
                                            <span class="text-muted">State:</span> {{formattedState(product.state)}}
                                        </div>
                                        <div v-if="product.grade || product.grade == '0'">
                                            <span class="text-muted">Grade:</span> <template v-if="product.grade == '0'"> K</template><template v-else> {{product.grade}}</template>
                                        </div>
                                        <div v-if="product.topic">
                                            <span class="text-muted">Subject:</span> {{product.topic}}
                                        </div>

                                        <div v-if="product.format" class="text-capitalize">
                                            <span class="text-muted">Format:</span>
                                            <template v-if="product.format == 'print_online'"> print &amp; online</template>
                                            <template v-else-if="product.format == 'online_only'"> online only</template>
                                            <template v-else> {{product.format}}</template>
                                        </div>
                                        <div v-if="product.language">
                                            <span class="text-muted">Language:</span>
                                            <template v-if="product.language == 'en'">
                                                <!-- <span class="flag-icon flag-icon-us mx-1"></span> --> English
                                            </template>
                                            <template v-else-if="product.language == 'es'">
                                                <!-- <span class="flag-icon flag-icon-es mx-1"></span> --> Spanish
                                            </template>
                                            <template v-else>{{product.language}}</template>
                                        </div>


                                    </small>

                                </div>

                                <div class="d-flex align-self-center ml-auto">

                                    <div class="align-self-center">

                                        <div class="d-flex flex-column">

                                            <div class="mb-2">
                                                <label class="small mb-1">
                                                    Quantity
                                                </label>
                                                <number-input v-model="product.quantity" size="small" :min="minQuantity(product)" :max="9999" controls @change="updateQuantity(product, $event)"></number-input>
                                            </div>

                                            <div v-if="product.teachers">
                                                <label class="small mb-1">
                                                    Teachers
                                                </label>
                                                <number-input v-model="product.teachers" size="small" :min="1" :max="maxTeachers(product)" controls @change="updateTeachers(product, $event)"></number-input>
                                            </div>
                                        </div>

                                    </div>

                                    <div class="align-self-center ml-3 text-right">

                                        <!-- <div>
                                            {{price(product.format, product.type, product.quantity)}} x {{product.quantity}}
                                        </div> -->

                                        <h6 class="my-1 align-self-center text-nowrap" v-if="product.format">
                                            <strike v-if="
                                                (price(product.prices, product.format, 'classroom', product.quantity, 1).yearstotal * multiyear)
                                                !=
                                                price(product.prices, product.format, 'classroom', product.quantity, multiyear).yearstotal">{{product.quantity * price(product.prices, product.format, 'classroom', product.quantity, 1).yearstotal * multiyear | currency}}</strike>
                                        </h6>

                                        <h6 class="my-1 align-self-center text-nowrap" v-if="product.format">
                                            {{product.quantity * price(product.prices, product.format, 'classroom', product.quantity, multiyear).yearstotal | currency}}
                                        </h6>

                                        <h6 class="my-1 align-self-center text-nowrap" v-else="product.format">
                                            {{product.quantity * product.price | currency}}
                                        </h6>

                                        <a href="#" class="text-danger" @click.prevent="removeItem(product)">
                                            Remove
                                        </a>

                                    </div>

                                </div>

                            </div>

                        </li>

                        <li class="list-group-item product" v-if="multiyear > 1">
                            <p class="text-muted text-lg-left my-auto">For a combination of multi-year orders, please call (866) 311-8734 for assistance.</p>
                        </li>
                    </ul>
                </div>

                <div class="container" v-if="shouldShowBundleMessage()">
                    <div class="row">
                        <div class="col-12 mb-4">
                            <p class="text-muted text-lg-left my-auto" style="font-size: 14px;">
                                <font-awesome-icon :icon="['fas', 'siren-on']" style="color: #EBB542;"/>
                                Don't miss out! Add any of these products: <span v-for="(product, productKey) in missingProducts(products)" :key="productKey">
                                    <button class="btn btn-link" style="font-size: 14px; padding:0px;" @click="doProductBundleOfferPopup(product)">{{product.title}} (+{{product.difference}})</button>
                                    <span v-if="productKey < missingProducts(products).length - 1">, </span>
                                </span> to your order<span v-if="!isHomeschoolStore"> for even greater savings</span>.
                            </p>
                        </div>
                    </div>
                </div>

                <div v-if="products && products.length && productsInCartToCheck == 0">
                    <div class="d-flex mb-3">
                        <div class="align-self-center">
                            <!-- CHECKOUT -->
                            <router-link
                                :to="{name: 'checkout'}"
                                class="btn btn-lg btn-success"
                                :class="{'disabled': subtotal >= 5000}"
                                :disabled="subtotal >= 5000"
                                @click.prevent="checkout"
                            >
                                <font-awesome-icon :icon="['fad', 'arrow-alt-from-left']" /> Checkout
                            </router-link>
                        </div>
                        <div class="align-self-center ml-auto">
                            <!-- SUBTOTAL -->
                            <label class="text-muted mr-2 mb-0">Subtotal</label>
                            <strong>{{subtotal | currency}}</strong>
                        </div>
                    </div>
                </div>

                <div v-if="!products || products && !products.length">
                    <p class="text-danger mb-lg-3 mb-0">0 items in cart</p>
                </div>

            </div>

        </section>

        <Footer />
    </div>
</template>

<style scoped>
.table td,
.table th {
    vertical-align: middle;
}

.text-small {
    font-size: 75%;
}

.cover-image {
    width: 60px;
    height: auto;
}

@media (min-width: 992px) {
    .product .form-control {
        max-width: 5rem;
    }
}

@media (max-width: 767px) {
    .cover-image {
        width: 50px;
    }
}
</style>

<style>
.number-input--small.number-input--controls>input {
    /* min-width: 120px; */
    /* width: 120px; */
    min-width: 120px;
}
</style>

<script>
import { mapState, mapGetters } from 'vuex'

//import product_prices from '@/common/product_prices'
import {publicationStates} from '@/common/states'
import multiyear_options from '@/common/multiyear_options'
import states_disallow_discount_codes from '@/common/states_disallow_discount_codes'

import Navbar from '@/components/Navbar'
import Footer from '@/components/Footer'
import TempAvailabilityMessage from "@/components/TempAvailabilityMessage";
import {productPricesOfFormat} from "@/common/utils";

export default {
    name: 'dashboard',
    data: () => ({
        // product_prices: product_prices,

        states: publicationStates,

        multiyear_options: multiyear_options,

        states_disallow_discount_codes: states_disallow_discount_codes,

        printOnlineMinimumQuantity: 10,

        current_year: new Date().getFullYear(),

        productsInCartToCheck: 1
    }),
    props: ['state'],
    components: {
        TempAvailabilityMessage,
        Navbar,
        Footer
    },
    computed: {
        ...mapState({
            products: state => state.cart.products,
            stateData: state => state.stateData.stateData,
            selectedState: state => state.stateData.selectedState,
            credentials: state => state.checkout.credentials,
            multiyear: state => state.cart.multiyear,
            cart: state => state.cart
        }),
        ...mapGetters(['showCurrentYearDisallowed', 'isHomeschoolStore']),
        multiyear_selected: {
            get () {
                return this.multiyear
            },
            set (multiyear_selected) {
                this.$store.commit('setMultiyearValue', multiyear_selected)
            }
        },
        subtotal () {
            var subtotal = []
            _.forEach(this.products, product => {
                var productTotal = null
                if (product.price) {
                    productTotal = (product.quantity * product.price)
                } else {
                    if(this.productsInCartToCheck == 0) {
                        productTotal = (product.quantity * this.price(product.prices, product.format, product.type, product.quantity, this.multiyear).yearstotal)
                    }
                    else
                    {
                        //No Prices Available
                        productTotal = 0
                    }
                }
                subtotal.push(productTotal)
            })
            return _.sum(subtotal)
        },
        containsWellBeing() {
            let value = false
            _.forEach(this.products, product => {
                if(product.topic == 'Well Being' || product.topic == 'Well-Being'){
                    value = true
                }
            })

            if(value == false) {
                //Reset Multi-Year Option to 1
                this.$store.commit('setMultiyearValue', multiyear_options[0])
            }

            return value
        },
        cartContainsPublications () {
            let value = false

            _.forEach(this.products, product => {

                if(!product.burrito) {
                    value = true
                }
            })

            //Might Be A Better User Experience, but for now we will leave it.
            if(value == false) {
                //Reset Multi-Year Option to 1
                this.$store.commit('setMultiyearValue', multiyear_options[0])
            }

            return value
        },
    },
    watch: {
        products: {
            deep: true,
            handler () {
                _.forEach(this.products, product => {
                    if (product && product.format) {
                        this.$set(product, "teachers", this.maxTeachers(product))
                    }
                })
            }
        }
    },
    methods: {
        getProductLink(product) {
            if (product.hasOwnProperty('page_link'))
                return product.page_link;

            return {
                name: this.formattedTopic(product.topic),
                params: {
                    state: product.state,
                    grade: product.grade,
                    subject: this.formattedTopic(product.topic),
                    language: product.language}
            };
        },
        shouldShowBundleMessage() {
            return false;
            return (this.isHomeschoolStore) || (this.missingProducts(this.products).length > 0 && this.isDiscountAllowedForCurrentState() == true)
        },
        updateQuantity (product, quantity) {
            this.$store.dispatch('updateQuantity', {
                product,
                quantity
            })
            this.$forceUpdate();
        },
        removeItem (product) {
            this.$store.dispatch('removeItem', product)
        },
        updateTeachers (product, teachers) {
            this.$store.dispatch('updateTeachers', {
                product,
                teachers
            })
        },
        // Misc utility methods
        // product_prices () {
        //     return this.product.prices
        // },
        updateMultiyear () {
            if(this.multiyear > 1) {
                _.forEach(this.products, product => {
                    if(!product.format) {
                    }
                    else if(product.quantity < 10) {
                        product.quantity = 10
                    }
                })
            }
        },
        price (product_prices, format, type, quantity, multiyear) {

            var prices = productPricesOfFormat(product_prices, format, quantity, this.isHomeschoolStore)[multiyear]

            return prices
        },
        price_old (format, type, quantity) {
            // TODO: can delete?
            if (format == 'online_only') return 5.49
            if (type == 'classroom' && quantity >= 10) return 7.95
            if (type == 'classroom' && quantity < 10) return 29.95
        },
        minQuantity (product) {
            // TMP character education, also why is this duplicated here?
            // Match general eduction but not health and wellness
            let regex = /HW-[0-9]{2}-GE-(?:EN|ES)-V[0-9]"/;
            let isHealthProduct = !product.sku.match(regex);
            if (product.sku == "POP" || product.topic == 'Character Education' || (product.topic == 'General Education' && !isHealthProduct))
                return 1;

            if(this.multiyear > 1) {
                if(product.format) {
                    return 10
                }
                else {
                    return 1
                }
            }
            else if (!this.isHomeschoolStore) {
                if (!product.format)
                    return 1;
                return 10
            }

            return 1

        },
        formattedState (productState) {
            var formattedState = null

            _.forEach(this.states, state => {
                if (productState == state.state) {
                    formattedState = state.fullState
                }
            })

            return formattedState
        },
        formattedTopic(topic) {
            if (topic) {
                topic = topic.replace(/\s+/g, '-').toLowerCase()
            }

            return topic
        },
        maxTeachers (product) {
            if (product) {
                let options = ([...Array(Math.floor((product.quantity-1)/25)+1).keys()].map(x => parseInt(x)+1))

                let maxTeachers = Math.max.apply(Math, options)

                return maxTeachers
            }
        },
        addProductToCart (product) {
            this.$store.dispatch('addItem', product)
        },
        getMatchingProduct(current_topic, current_grade, current_language) {
            let new_topic
            let new_bundle_publication = null
            let new_bundle_publication_new = null
            let new_bundle_product = {}

            if(current_topic == 'Social Studies' || current_topic == 'National Social Studies') {
                new_topic = 'Science'
            }
            else {
                new_topic = 'Social Studies'
            }

            _.forEach(this.stateData.publications, publication => {
                if (publication.topic == new_topic && publication.grade == current_grade && publication.language == current_language) {
                    new_bundle_publication = publication

                    if(publication.topic == 'National Social Studies') {
                        new_bundle_publication_new = publication
                    }
                }
            })

            return new_bundle_publication
        },
        getCountOfProductInCart(topic, grade, language) {

            let qty = 0
            let product

            for (product of this.products) {
                if(product.topic == topic && product.grade == grade && product.language == language) {
                    qty = qty + product.quantity
                }
            }

            return qty
        },
        getReadableGrade(grade) {
            let readableGrade

            readableGrade = grade

            if(grade == 0) {
                readableGrade = 'K'
            }
            else if(grade == 1) {
                readableGrade = grade + 'st'
            }
            else if(grade == 2) {
                readableGrade = grade + 'nd'
            }
            else if(grade == 3) {
                readableGrade = grade + 'rd'
            }
            else if(grade > 3) {
                readableGrade = grade + 'th'
            }

            return readableGrade
        },
        missingProducts (products) {

            let product
            let product_count

            let matching_product
            let matching_product_count

            let difference

            let missingProducts = []

            for (product of products) {
                product_count = this.getCountOfProductInCart(product.topic, product.grade, product.language)

                matching_product = this.getMatchingProduct(product.topic, product.grade, product.language)

                if (matching_product != null && (product.topic == 'Science' || product.topic == 'Social Studies' || product.topic == 'National Social Studies')) {

                    matching_product_count = this.getCountOfProductInCart(matching_product.topic, matching_product.grade, matching_product.language)

                    if(product_count != matching_product_count) {

                        if(product_count > matching_product_count) {

                            // console.log(product_count + '>' + matching_product_count)

                            // console.log(product.title)

                            difference = product_count - matching_product_count

                            // console.log('----------difference=' + difference + '---------')

                            // console.log(this.getReadableGrade(matching_product.grade) + ' ' + matching_product.topic + ' - ' + matching_product.id)
                            // console.log('-------------------')

                            missingProducts.push({'topic': matching_product.topic,'grade': matching_product.grade, 'language': matching_product.language, 'id': matching_product.id, 'difference': difference, 'state': matching_product.state, 'title': this.getReadableGrade(matching_product.grade) + ' ' + matching_product.topic })
                        }
                    }
                }
            }

            return missingProducts
        },
        doProductBundleOfferPopup(product) {
            let topic_for_url

            if(this.isDiscountAllowedForCurrentState() == true) {

                //Redirect to product.  Could add a popup or something, but for now keeping it simply.
                //--------------------
                topic_for_url = product.topic.replace(/\s+/g, '-').toLowerCase()

                this.$router.push(topic_for_url + '/' + product.state + '/' + product.grade + '/' + product.language);

                //this.$bvModal.show('bundle-product-modal')
                //--------------------
            }
        },
        isDiscountAllowedForCurrentState () {
            if(states_disallow_discount_codes.includes(this.selectedState) == true) {
                return false
            }
            else {
                return true
            }
        },
        setProductBundleDismissed() {
            this.hideBundleDiscountModal()
        },
        hideBundleDiscountModal () {
            this.$bvModal.hide('bundle-product-modal')
        }
    },
    mounted () {

        this.$store.commit('setQuote', null);// Clear Quote Checkout
        this.productsInCartToCheck = this.products.length

        //Delete Pricing - For Testing Only
        // _.forEach(this.products, product => {
        //Deleting to Check New Prices
        //delete product.prices
        // })

        _.forEach(this.products, product => {
            if(product.prices) {
                //Prices Exist
                //All Good

                this.productsInCartToCheck--
            }
            else {
                //Prices Don't Exist Due to Old Cart or Other Reason

                //Only Do This If Product In Cart Is Old
                //Might use this endpoint to make this more optimized.

                let newProductObject

                newProductObject = product

                // TODO: can I get rid of this?
                this.axios.get("costs/product/all-prices/" + this.current_year + "/" + product.legacy_id)
                    .then(response => {
                        //Remove Product w/o Prices
                        this.removeItem (product)

                        newProductObject.prices = response.data.prices

                        delete newProductObject.prices[1].success
                        delete newProductObject.prices[2].success
                        delete newProductObject.prices[3].success
                        delete newProductObject.prices[4].success
                        delete newProductObject.prices[5].success
                        delete newProductObject.prices[6].success
                        delete newProductObject.prices[7].success
                        delete newProductObject.prices[8].success

                        //Add Same Product w/ Prices
                        this.addProductToCart(newProductObject)

                        this.productsInCartToCheck--
                    })
                    .catch(error => {
                        this.$swal("Error", error.message, "error")
                    })
            }
        })
    }
}
</script>
